export default __webpack_public_path__ + "static/media/3531224b-vidchain.1ad1bd94.svg";